var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"company-invoice-card"},[_c('div',{staticClass:"d-flex align-center"},[_c('p',{staticClass:"card-title"},[_vm._v(" "+_vm._s(_vm.$t('purchaseV2.basket.companyInvoice'))+" ")]),_c('v-switch',{staticClass:"pl-2",attrs:{"color":"primary","input-value":_vm.isCompanyInvoice},on:{"change":_vm.onToggleInvoice}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }